import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import SubActivityPrint from '../sub-activity/sub-activity-print';
import { ViewProps } from './response.constants';
import * as Styled from './response-print.style';
import { useResponseBaseHeight } from './response.hooks';
import { ZoomComponentTrigger } from 'approot/activity-builder/activity-builder-zoom-component-modal';

const ResponsePrint = ({
  properties,
  subActivityProperties,
  openModal,
}: ViewProps) => {
  const baseHeight = useResponseBaseHeight();
  const sortedFields = useMemo(
    () => sortBy(properties.textResponse.fields, 'sort'),
    [properties.textResponse.fields]
  );
  return (
    <>
      {openModal && <ZoomComponentTrigger openModal={openModal} />}
      <SubActivityPrint subActivityDetails={subActivityProperties}>
        <Styled.ResponseContainer>
          {sortedFields.map(field => (
            <Styled.ResponseBox
              key={field.itemId}
              $baseColour={field.baseColour}
            >
              {[...Array(field.numberOfLines)].map((_, i) => (
                <Styled.ResponseField
                  key={i}
                  $baseHeight={baseHeight}
                  data-selector="response-line-print"
                >
                  {i === 0 && field.isPlaceholderScaffold && (
                    <span>{field.placeholder}</span>
                  )}
                </Styled.ResponseField>
              ))}
            </Styled.ResponseBox>
          ))}
        </Styled.ResponseContainer>
      </SubActivityPrint>
    </>
  );
};
export default ResponsePrint;
